import React, { useEffect, useMemo, useState } from "react";
import { SideNav, SideNavContent } from "components";
import PageHeader from "components/UniversalComponents/PageHeader";
import {
  BaseDropdown,
  LargeButton,
  MainBody,
  OverlayLoader,
  Ptag,
} from "components/core";
import http from "services/httpService";
import { CardContainer } from "./styles";
import UploadFile from "components/UploadFile";
import { handleFileGeneration } from "../utils";
import InsurerCard from "../components/InsurerCard";
import { Form, Formik } from "formik";

function ClientIdGenerator() {
  const [serviceProviders, setServiceProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [documentId, setDocumentId] = useState();

  console.log({ selectedProvider });

  useEffect(() => {
    (async function () {
      await getServiceProviders();
    })();
  }, []);

  const getServiceProviders = async () => {
    const { data } = await http.get("/business/service_provider_selectables/", {
      params: {
        filter_by_config: true,
      },
    });
    setServiceProviders(data);
    setIsLoading(false);
  };

  const handleSubmit = (values) => {
    console.log({ values });
    handleFileGeneration(documentId, selectedProvider, values.type);
  };

  const enrolmentTypeOptions = useMemo(() => {
    switch (selectedProvider) {
      case 5:
        return [
          { label: "Inception", value: "inception" },
          { label: "Endorsement", value: "endorsement" },
        ];
      case 15:
        return [
          { label: "Inception", value: "inception" },
          { label: "Addition", value: "addition" },
          { label: "Deletion", value: "deletion" },
          { label: "Correction", value: "correction" },
        ];
    }
    return [{ label: "Inception", value: "inception" }];
  }, [selectedProvider]);

  console.log({ selectedProvider, documentId });
  if (isLoading) return <OverlayLoader />;
  return (
    <>
      <div
        style={{
          backgroundColor: "white",
          minHeight: "100%",
          flex: 1,
          borderRadius: "20px",
          padding: "4rem",
          position: "relative",
        }}
      >
        <div
          style={{
            maxWidth: "1000px",
          }}
        >
          <Ptag fontSize="18px">Select Insurer</Ptag>
          <CardContainer>
            {serviceProviders.map((insurer, index) => (
              <InsurerCard
                key={index}
                insurer={insurer}
                isSelected={insurer.service_provider_id === selectedProvider}
                onClick={() => setSelectedProvider(insurer.service_provider_id)}
              />
            ))}
          </CardContainer>
          <Ptag fontSize="12px" fontWeight="400" marginTop="6px">
            Supported Insurers: {serviceProviders.length}
          </Ptag>
          {selectedProvider && (
            <div>
              <Formik
                initialValues={{
                  type: "inception",
                }}
                onSubmit={handleSubmit}
              >
                {(formikProps) => (
                  <Form>
                    <div style={{ marginTop: "3rem" }}>
                      <Ptag fontSize="18px" marginBottom="20px">
                        Enrolment Type
                      </Ptag>
                      <BaseDropdown
                        fontSize="14"
                        options={enrolmentTypeOptions}
                        formikProps={{ ...formikProps, name: "type" }}
                      />
                    </div>

                    <div
                      style={
                        {
                          // marginBottom: "8rem"
                        }
                      }
                    >
                      <UploadFile
                        label="Insurer File"
                        text="Upload File"
                        format="excel"
                        type="employee_wise_breakup"
                        onSelect={setDocumentId}
                      />
                    </div>
                    <LargeButton
                      type="submit"
                      disabled={!documentId || !selectedProvider}
                      label="Generate"
                      style={{
                        // width: "calc(100% - 8rem)",
                        maxWidth: "1000px",
                        marginTop: "2rem",
                        // position: "absolute",
                        cursor:
                          !documentId || !selectedProvider
                            ? "not-allowed"
                            : "pointer",
                        opacity: !documentId || !selectedProvider ? 0.5 : 1,
                      }}
                    />
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ClientIdGenerator;
